/* eslint-disable import/prefer-default-export */
import axios from "axios";
import * as Sentry from "@sentry/react";

import {
  SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM,
  SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM_ERROR,
  EMAIL_ALREADY_TAKEN_ERROR,
  PROCEED_TO_NEXT_FORM_STEP,
  SET_FORM_LOADING,
} from "./types";

export const proceedToNextFormStep = () => (dispatch) => {
  window.scrollTo({
    top: 0,
  });

  dispatch({
    type: PROCEED_TO_NEXT_FORM_STEP,
  });
};

export const submitForm = (formData) => async (dispatch) => {
  dispatch({
    type: SET_FORM_LOADING,
  });

  const recruiterUserData = {
    first_name: formData.firstName.trim(),
    last_name: formData.lastName.trim(),
    email: formData.email.trim(),
    recruiter_attributes: {
      phone_number: formData.phone,
      name: formData.companyName.trim(),
      account_type: "portal",
      public_jobs: false,
      agree_to_terms: formData.termsAgreed,
    },
  };

  const payload = {
    url: "/recruiter/register/portal_create",
    method: "post",
    data: {
      recruiter_user: recruiterUserData,
    },
  };

  try {
    await axios(payload);

    dispatch({
      type: SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM,
    });

    dispatch(proceedToNextFormStep());
  } catch (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors.email
    ) {
      dispatch({
        type: EMAIL_ALREADY_TAKEN_ERROR,
      });
    } else {
      Sentry.captureException(error);

      dispatch({
        type: SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM_ERROR,
      });
    }
  }
};
